import { PMREMGenerator, WebGLRenderer } from "three";

import EnvironmentScene from "../utils/CustomRoomEnvironment";

export function environment(renderer: WebGLRenderer) {
  const pmremGenerator = new PMREMGenerator(renderer);
  pmremGenerator.compileCubemapShader();
  let envScene = new EnvironmentScene('customKicks', () => {
    pmremGenerator.compileCubemapShader();
  });

  const generator = pmremGenerator.fromScene(envScene, 0.85, 0.01, 500 );
  envScene.children = [];

  return generator;
}
